
import { defineComponent, PropType } from "vue";

import Action from "@/models/Action";
import Player from "@/models/Player";
import PrivatePlayerState from "@/models/PrivatePlayerState";
import Resource, { getResourceIcon } from "@/models/Resource";

import CardDeck from "@/components/Elements/CardDeck.vue";
import ResourceCard from "@/components/Elements/ResourceCard.vue";
import DevelopmentCard from "@/components/Elements/DevelopmentCard.vue";
import PopupMenu from "@/components/Elements/PopupMenu.vue";

export default defineComponent({
  inject: ["game"],
  data: () => ({
    tradingResource: null as Resource | null,
  }),
  props: {
    player: { type: Object as PropType<Player>, required: true },
  },
  computed: {
    playerState(): PrivatePlayerState | null {
      return this.game.privateState;
    },
    availableActions(): Action[] {
      return this.game.availableActions;
    },
    tradableResources(): Resource[] {
      if (this.playerState && this.availableActions.includes("Trade")) {
        return [
          Resource.Brick,
          Resource.Grain,
          Resource.Lumber,
          Resource.Ore,
          Resource.Wool,
        ].filter(
          (resource) =>
            this.playerState!.resources[resource] >=
            this.playerState!.exchangeRates[resource]
        );
      } else {
        return [];
      }
    },
    tradingExchangeRate(): number {
      return this.tradingResource
        ? this.playerState?.exchangeRates[this.tradingResource] ?? 0
        : 0;
    },
  },
  methods: {
    getResourceIcon,
    startBuildingSettlement() {
      this.game.startBuildingSettlement();
    },
    startBuildingCity() {
      this.game.startBuildingCity();
    },
    startBuildingRoad() {
      this.game.startBuildingRoad();
    },
    collect(resource: Resource) {
      this.game.collectResource(resource);
    },
    discard(resource: Resource) {
      this.game.discardResource(resource);
    },
    startTrading(resource: Resource) {
      this.tradingResource = resource;
    },
    trade(resource: Resource) {
      this.game.trade(this.tradingResource!, resource);
      this.tradingResource = null;
    },
    cancelTrading() {
      this.tradingResource = null;
    },
    buyDevelopmentCard() {
      this.game.buyDevelopmentCard();
    },
    playDevelopmentCard(cardId: number) {
      this.game.playDevelopmentCard(cardId);
    },
  },
  components: { CardDeck, ResourceCard, DevelopmentCard, PopupMenu },
});
